export const getLocation = (): any => window.location;
export const getOpenerLocation = (): any => window.opener.location;
